import React, { Component } from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import Loader from '../../HOME/COMPONENTS/Loader';
import { TRANSITION_DURATION, TRIOMINOS_PER_LEVEL } from '../const';
import Cell from './Cell';
import * as f from '../logic';
import _ from 'lodash';
import { windowSize, delay, dbget, dbset } from '../../HOME/utils';
import { Sound } from '../../HOME/Sound';
import Trio from './Trio';
import { setShapes, setScore, setTimeLeft, setLevel, updateStats, showIntro } from '../REDUX/actions';
import { setLevelsCompleted, setStartLevel, setIntroduced, pause } from '../REDUX/actions';
import MessageBox from '../../HOME/COMPONENTS/MessageBox';
import { OVER_RESTART, SHOW_LEADERS } from '../../HOME/REDUX/actions';
import { requestResetStats, requestSurrender, showLeaderboards, goToPage } from '../../HOME/REDUX/actions';
import ResumeIcon from '../../HOME/SVG/PlayIcon';
import Intro from './Intro';
import { SKILL_PAGE } from '../../HOME/const';
import GameOverOptions from '../../HOME/COMPONENTS/GameOverOptions';

class Board extends Component {
  constructor(props) {
    super(props);

    this.state = { trio: 0 };
    this.trioRefs = [React.createRef(), React.createRef()];
    this.cellRefs = [];

    for (let i = 0; i < props.size * props.size; i++) {
      this.cellRefs.push(React.createRef());
    }
  }

  onResize = () => {
    this.forceUpdate();
  };

  componentDidMount() {
    window.addEventListener('resize', this.onResize);

    this.load();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);

    if (!this.state.over) {
      this.save();
    }

    this.resetTimer(0);
    this.props.requestResetStats(false);
    this.props.requestSurrender(false);
    this.props.pause(false);
    this.props.showIntro(false);
  }

  load = () => {
    dbget(f.boardKey(this.props), json => {
      if (!json) {
        this.init();

        dbget(f.levelsCompletedKey(this.props), level => {
          this.props.setLevelsCompleted(level > 0 ? level : 0);

          if ((level || 0) < 1) {
            this.props.setLevel(1);
            this.props.setStartLevel(1);
          }
        });

        return;
      }

      this.props.pause(true);

      const { steps, score, palette, shapes, cells, trios, level, startLevel, timeLeft } = this.fromJson(json);

      this.palette = palette;
      this.cells = cells;
      this.trios = [this.createTrio(trios[0]), this.createTrio(trios[1])];
      this.props.setShapes(shapes);
      this.props.setScore(steps, score);
      this.props.setLevel(level);
      this.props.setStartLevel(startLevel);
      this.props.setTimeLeft(timeLeft || undefined);

      // this.updateDots();
    });
  };

  handleResume = () => {
    this.props.pause(false);

    Promise.resolve().then(() => {
      this.updateDots();
      this.setTimer();
    });
  };

  restart = () => {
    if (this.props.levelsCompleted > 0) {
      this.props.goToPage(SKILL_PAGE);
      return;
    }

    this.setState({ over: false, restarting: true }, () => {
      this.setState({ restarting: false });
    });

    this.init();

    this.props.setLevel(this.props.startLevel);
  };

  init = () => {
    this.playSound('dice');
    this.surrender = false;

    this.createPalette();
    this.trios = [this.createTrio(), this.createTrio()];

    this.cells = [];
    const { size } = this.props;

    for (let row = 1; row <= size; row++) {
      for (let col = 1; col <= size; col++) {
        var cell = new Cell();

        cell.row = row;
        cell.col = col;
        cell.hasDot = row > 1 && col > 1;

        this.cells.push(cell);
      }
    }

    this.props.setScore(0, 0);
    this.props.setTimeLeft();
    this.setTimer();

    this.forceUpdate();
  };

  gameOver = () => {
    const over = _.every(this.cells, cell => !cell.hasDot);
    return over;
  };

  handleConfirmSurrender = yes => {
    this.props.pause(false);

    if (yes) {
      f.setStats(this.props);
      this.setState({ over: true }, () => this.restart());
    }

    delay(() => this.props.requestSurrender(false));
  };

  handleConfirmResetStats = yes => {
    this.props.pause(false);

    if (yes) {
      this.props.updateStats();
    }

    delay(() => this.props.requestResetStats(false));
  };

  createPalette = () => {
    const count = this.props.size - 2;
    this.palette = _.sampleSize(['red', 'yellow', 'green', 'blue', 'magenta'], count);
    const forms = _.sampleSize(['square', 'circle', 'vert', 'horz', 'plus'], count);

    const shapes = {};

    for (let i = 0; i < count; i++) {
      const color = this.palette[i];
      shapes[color] = forms[i];
    }

    this.props.setShapes(shapes);
  };

  createTrio = t => {
    return {
      hole: t ? t.hole : _.random(0, 3),
      colors: t ? t.colors : _.sampleSize(this.palette, this.props.size - 2),
    };
  };

  onClick = cell => {
    this.playSound('click');

    const trio = this.trioRefs[this.state.trio].current;
    const r1 = trio.rect;
    const r2 = cell.rect;

    const dx = r2.x - cell.props.width - r1.x + 1;
    const dy = r2.y - cell.props.width - r1.y + 1;

    this.setState({ transform: `translate(${dx}px, ${dy}px)` }, () => {
      this.updateToolbar();
      delay(() => {
        this.onEndTransition(cell);
      }, TRANSITION_DURATION);
    });
  };

  eraseCells = destCells => {
    const { size } = this.props;
    let count = 0;

    _.each(destCells, cell => {
      let erase;

      for (var i = 0; i < 4; i++) {
        let { row, col } = cell;

        if (i === 0) {
          --col;
        } else if (i === 1) {
          --row;
        } else if (i === 2) {
          ++col;
        } else if (i === 3) {
          ++row;
        }

        if (row < 1 || row > size || col < 1 || col > size) {
          continue;
        }

        const acell = this.cells[this.cellIndex(row, col)];

        if (acell.color === cell.color) {
          erase = true;
          acell.prevColor = acell.color;
          acell.color = 'transparent';
          ++count;
        }
      }

      if (erase) {
        cell.prevColor = cell.color;
        cell.color = 'transparent';
        ++count;
      }
    });

    this.playSound(count === 0 ? 'cluck' : count === 2 ? 'coin1' : count < 5 ? 'coin2' : 'coins');

    const { steps, score, level, startLevel } = this.props;

    if (startLevel > 1 && level === startLevel && (level < 4 || steps <= TRIOMINOS_PER_LEVEL)) {
      count *= startLevel;
    }

    this.props.setScore(steps + 1, score + count);
  };

  updateDots = () => {
    _.each(this.cells, cell => {
      if (cell.row < 2 || cell.col < 2) {
        return;
      }

      const cells = this.getDestinationCells(cell);
      cell.hasDot = _.every(cells, c => !c.color || c.color === 'transparent');
    });

    this.forceUpdate();
  };

  cellIndex = (row, col) => {
    return (row - 1) * this.props.size + col - 1;
  };

  getDestinationCells = clickCell => {
    const trio = this.trioRefs[this.state.trio].current;

    if (!trio) {
      return;
    }

    const { row, col } = clickCell;
    const cells = [];

    for (let i = 0; i < 4; i++) {
      if (trio.props.hole === i) {
        continue;
      }

      let index;

      switch (i) {
        case 0:
          index = this.cellIndex(row - 1, col - 1);
          break;
        case 1:
          index = this.cellIndex(row - 1, col);
          break;
        case 2:
          index = this.cellIndex(row, col - 1);
          break;
        case 3:
          index = this.cellIndex(row, col);
          break;
        default:
      }

      const cell = this.cells[index];
      cells.push(cell);
    }

    return cells;
  };

  playSound = name => {
    Sound(name, this.props.globalOptions.volume);
  };

  blocked = () => this.state.transform || this.props.intro;

  onEndTransition = clickCell => {
    delay(() => {
      const destCells = this.getDestinationCells(clickCell);
      const trio = this.trioRefs[this.state.trio].current;

      for (let i = 0; i < 3; i++) {
        destCells[i].color = trio.props.colors[i];
      }

      this.forceUpdate();
      this.eraseCells(destCells);

      this.trios[this.state.trio] = this.createTrio();

      this.setState({ nextFade: true, transform: undefined, trio: 1 - this.state.trio }, () => {
        this.updateToolbar();
        this.updateDots();

        const over = this.gameOver();
        this.setState({ over });

        if (over) {
          this.playSound('won');

          this.props.requestResetStats(false);
          this.props.requestSurrender(false);
        }

        const { level, steps } = this.props;
        const levelCompleted = level < 4 && steps % TRIOMINOS_PER_LEVEL === 0;

        if (levelCompleted) {
          dbset(f.levelsCompletedKey(this.props), level);
          this.props.setLevelsCompleted(level);
        }

        if (over) {
          this.resetTimer(0);
          f.setStats(this.props);
        } else {
          this.save();

          if (levelCompleted) {
            this.props.setLevel(level + 1);
            this.props.setTimeLeft();

            delay(() => {
              this.props.showIntro(true);
              this.playSound('draw');
            }, 300);
          }

          return;
        }
      });

      delay(() => {
        this.setState({ nextFade: false });

        if (!this.state.over) {
          this.props.setTimeLeft();
          this.setTimer();
        }
      }, 1);
    }, 100);
  };

  save = () => {
    dbset(f.boardKey(this.props), this.toJson());
  };

  toJson = () => {
    const { steps, score, shapes, level, startLevel, timeLeft } = this.props;
    const { palette, cells } = this;

    const trios = [];

    _.each(this.trios, t => {
      trios.push({ hole: t.hole, colors: t.colors });
    });

    const json = JSON.stringify({ steps, score, palette, shapes, cells, trios, level, startLevel, timeLeft }, [
      'steps',
      'score',
      'palette',
      'shapes',
      'red',
      'yellow',
      'green',
      'blue',
      'magenta',
      'cells',
      'row',
      'col',
      'color',
      'trios',
      'hole',
      'colors',
      'level',
      'startLevel',
      'timeLeft',
    ]);

    return json;
  };

  fromJson = json => {
    return JSON.parse(json);
  };

  updateToolbar = () => {
    this.props.toolbar.current.forceUpdate();
  };

  handleContinue = () => {
    this.props.showIntro(false);
    this.setTimer();
  };

  setTimer = () => {
    clearInterval(this.interval);

    const { level } = this.props;

    if (!level || level < 2) {
      return;
    }

    this.interval = setInterval(() => {
      if (this.props.paused || this.blocked()) {
        return;
      }

      const time = this.props.timeLeft - 1;
      this.props.setTimeLeft(time);

      if (time === 0 && !this.blocked()) {
        this.resetTimer(0);

        const dot = _.sample(_.filter(this.cells, cell => cell.hasDot));
        const cell = _.find(this.cellRefs, r => r.current.props.cell === dot).current;
        this.onClick(cell);
      }
    }, 1000);
  };

  resetTimer = time => {
    clearInterval(this.interval);
    this.interval = null;
    this.props.setTimeLeft(time);
  };

  handleGameOver = op => {
    if (op === SHOW_LEADERS) {
      this.props.showLeaderboards();
    } else if (op === OVER_RESTART) {
      this.restart();
    }
  };

  renderTrio = (i, cellWidth) => {
    const current = i === this.state.trio;
    const transform = this.state.transform;
    const transformTransition = `transform ${TRANSITION_DURATION}ms linear`;
    const opacityTransition = `opacity ${TRANSITION_DURATION}ms linear`;

    let transition;

    if (transform) {
      transition = current ? transformTransition : opacityTransition;
    } else {
      transition = current || this.state.nextFade ? undefined : opacityTransition;
    }

    const style = current ? { transition, transform } : { transition };
    const opacity = current ? 1 : transform ? 1 : this.state.nextFade ? 0 : 0.15;
    const trio = this.trios[i];

    return <Trio ref={this.trioRefs[i]} style={{ opacity, ...style }} hole={trio.hole} colors={trio.colors} cellWidth={cellWidth} />;
  };

  render() {
    if (!this.cells || !this.trios) {
      return <Loader width={125} />;
    }

    const { size } = this.props;
    const { x, y } = windowSize();
    let width = Math.min(x, y - 200);
    width = Math.min(width, 600);

    do {
      width *= 0.9;
      var cellWidth = (width + size - 1) / size;
    } while (cellWidth * (size + 2) > y - 200);

    width = `${width}px`;
    const grid = `${_.repeat('auto ', size)}/${_.repeat('auto ', size)}`;
    const background = this.state.over ? 'rgb(0,0,0)' : 'initial';
    const transition = 'background 500ms linear';

    const { over, trio, restarting } = this.state;
    const gridArea = over ? (trio ? '1/1' : '1/3') : '';
    const trioWidth = cellWidth * 2;

    const opacity = restarting ? 0 : 1;
    const trayTransition = restarting ? 'initial' : 'opacity 1s linear';

    return (
      <div className="tt-board-container">
        {this.props.paused ? (
          <div className="ms-resume fadein-slow" onClick={this.handleResume}>
            {this.props.resetStats || this.props.surrender ? null : (
              <>
                <span className="ms-game-paused">GAME PAUSED</span>
                <ResumeIcon width="100px" style={{ gridArea: '1/1' }} />
              </>
            )}
          </div>
        ) : this.props.intro ? (
          <Intro onContinue={this.handleContinue} />
        ) : (
          <div style={{ gridArea: '1/1', display: 'grid' }}>
            <div className="tm-tray">
              {over && trio ? null : (
                <span style={{ gridArea: '1/1', zIndex: 1, opacity, transition: trayTransition }}>{this.renderTrio(0, cellWidth)}</span>
              )}
              {over && !trio ? null : (
                <span style={{ gridArea: '1/3', zIndex: 1, opacity, transition: trayTransition }}>{this.renderTrio(1, cellWidth)}</span>
              )}
              {over && <div style={{ gridArea, width: trioWidth }} />}
            </div>
            <div className="tt-board" style={{ gridArea: '2/1', width, height: width, grid, background, transition }}>
              {_.map(this.cells, (cell, i) => {
                return <Cell key={i} ref={this.cellRefs[i]} board={this} width={cellWidth} cell={cell} shapes={this.props.shapes} />;
              })}
            </div>
            {over && !this.props.resetStats && <GameOverOptions handleResponse={this.handleGameOver} style={{ gridArea: '1/1/span 2/1' }} />}
          </div>
        )}
        {this.props.surrender ? (
          <div className="ms-message-screen">
            <MessageBox message="Start over?" yesNo onReply={this.handleConfirmSurrender} />
          </div>
        ) : null}
        {this.props.resetStats ? (
          <div className="ms-message-screen">
            <MessageBox message="Reset stats?" yesNo onReply={this.handleConfirmResetStats} />
          </div>
        ) : null}
      </div>
    );
  }
}

function mapStateToProps({ tm, common }) {
  return { ...tm, ...common };
}

export default connect(
  mapStateToProps,
  {
    setShapes,
    setScore,
    requestResetStats,
    requestSurrender,
    showLeaderboards,
    goToPage,
    setTimeLeft,
    setLevel,
    updateStats,
    setLevelsCompleted,
    setStartLevel,
    setIntroduced,
    showIntro,
    pause,
  },
  null,
  { forwardRef: true }
)(Board);
